module.exports = __webpack_public_path__ + "img/home_logo.64fd4af6.png";